export default __webpack_public_path__ + "static/media/red-velvet.635e5dad.jpg";